import { useTheme } from 'styled-components';

import { Typography } from '@libs/components';

import { useTranslation } from 'src/hooks';
import {
  CustomTypography,
  DescriptionsWrapper,
  DescriptionWrapper,
  ReferralOfferContainer,
  ReferralOfferTitleWrapper,
} from './styles';

type ReferralIntroduceOfferProps = {
  className?: string;
};
export const ReferralIntroduceOffer: React.FC<ReferralIntroduceOfferProps> = ({
  className,
}) => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  return (
    <ReferralOfferContainer className={className}>
      <ReferralOfferTitleWrapper>
        <Typography fontFamily="primaryBold" type="bodyButton">
          {t('referral_promotion_offer_title')}
        </Typography>
      </ReferralOfferTitleWrapper>

      <DescriptionsWrapper>
        <DescriptionWrapper>
          <Typography type="titleTwo" fontFamily="primaryBold">
            {t('referral_rule_details_second_title')}
          </Typography>
          <CustomTypography
            type="bodyButton"
            fontFamily="primaryRegular"
            color={colors.text.secondary}
          >
            {t('referral_promotion_offer_description_first')}
          </CustomTypography>
        </DescriptionWrapper>
      </DescriptionsWrapper>
    </ReferralOfferContainer>
  );
};
